export const ERROR_MESSAGE = {
    ALREADY_EXIST: 'ALREADY_EXIST',
    MISSING_ROLE: 'MISSING_ROLE',
}

/**
 * @class
 * TDDError custom class
 * @extends Error
 */
export default class TTDError extends Error {
    isTTD: boolean | undefined

    /**
     *
     * @param {string} message error message
     * @param {boolean} isTTD is internal or from TTD
     */
    constructor(message: string, isTTD?: boolean) {
        super(message)
        this.isTTD = isTTD
    }
}
